import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

import { useRegion } from '../RegionChooser/hook'

const useStyles = makeStyles((theme: Theme) => {
  const getHeight = (variant?: string) => {
    const isHeader = variant && variant.length > 0
    return isHeader ? '46px' : '56px'
  }

  return createStyles({
    form: {
      marginLeft: theme.spacing(4),
      display: 'flex',
      height: (props: IProps) => getHeight(props.variant),
      border: `2px solid #0076cf`,
      borderRadius: '5px',
    },
    input: {
      marginLeft: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      width: '2.5em',
      backgroundColor: '#0076cf',
      color: '#fff',
      paddingTop: 0,
      paddingBottom: 0,
      borderRadius: '0',
      display: 'block',

      '&:hover': {
        backgroundColor: '#0076cf',
      },

      '& .MuiSvgIcon-root': {
        paddingTop: '4px',
        width: '1.5em',
        height: '1.5em',
      },
    },
  })
})

interface IProps {
  variant?: string
  placeholder?: string
}

const Searchbar = (props: IProps) => {
  const { t, ready } = useTranslation(
    props.variant === 'graphic' ? 'GraphicSearchbar' : 'Searchbar',
    {
      useSuspense: false,
    }
  )
  const { ready: rReady, path } = useRegion()

  const [searchPath, setSearchPath] = useState('/')
  const [fieldName, setFieldName] = useState('s')
  const classes = useStyles(props)

  useEffect(() => {
    if (!rReady) {
      return
    }

    if (props.variant === 'graphic') {
      setSearchPath(path.replace(/(.*)\//g, '$1') + '/templates/')
      setFieldName('qs')
    } else {
      setSearchPath(path)
    }
  }, [rReady])

  if (!rReady) {
    return null
  }

  if (!ready) {
    return null
  }

  return (
    <form
      action={searchPath}
      role="search"
      method="get"
      className={classes.form}
    >
      <InputBase
        name={fieldName}
        className={classes.input}
        placeholder={props.placeholder ?? t('placeholder')}
        inputProps={{ 'aria-label': t('placeholder') }}
      />
      <IconButton
        type="submit"
        className={classes.iconButton}
        aria-label={t('button')}
        title={t('button')}
      >
        <SearchIcon />
      </IconButton>
    </form>
  )
}

export default (element: Element) => {
  ReactDOM.render(
    <Searchbar
      variant={element.getAttribute('data-variant')}
      placeholder={element.getAttribute('data-placeholder')}
    />,
    element
  )
}
